import { Result } from '../../../../common/models/Result';
import { HttpServiceBase } from '../../../../common/services/HttpServiceBase';
import { Recipe } from '../../../models/Recipe';

export class CreateAndLinkOrderRecipeFromCustomerRecipeService extends HttpServiceBase {

  handle = (input: CreateAndLinkOrderRecipeFromCustomerRecipeInput): Promise<Result<CreateAndLinkOrderRecipeFromCustomerRecipeOutput> | null> => {
    const promise = this.http.post<Result<CreateAndLinkOrderRecipeFromCustomerRecipeOutput>, CreateAndLinkOrderRecipeFromCustomerRecipeInput>(
        `${this.baseUrlSislogApi}/point-of-sale/order-recipe-creation-and-linking?apiKey=${this.getSislogApiKey()}`,
        input);
    return promise;
  }
}

export class CreateAndLinkOrderRecipeFromCustomerRecipeInput {
  orderId?: number|null;
  shopifyOrderId?: number|null;
  customerRecipeId?: number|null;
}

export class CreateAndLinkOrderRecipeFromCustomerRecipeOutput {
  recipe?: Recipe|null;
}